/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Domain,
  IPAddress,
  PaginatedDomainList,
  PaginatedIPAddressList,
  PaginatedPortList,
  PaginatedSubdomainList,
  Port,
  Subdomain,
} from '../models/index';
import {
    DomainFromJSON,
    DomainToJSON,
    IPAddressFromJSON,
    IPAddressToJSON,
    PaginatedDomainListFromJSON,
    PaginatedDomainListToJSON,
    PaginatedIPAddressListFromJSON,
    PaginatedIPAddressListToJSON,
    PaginatedPortListFromJSON,
    PaginatedPortListToJSON,
    PaginatedSubdomainListFromJSON,
    PaginatedSubdomainListToJSON,
    PortFromJSON,
    PortToJSON,
    SubdomainFromJSON,
    SubdomainToJSON,
} from '../models/index';

export interface AssetsAllScreenshotsListRequest {
    teamSlug: string;
    limit?: number;
    page?: number;
}

export interface AssetsPortsForAssetRetrieveRequest {
    teamSlug: string;
}

export interface AssetsPortsRetrieveRequest {
    assetId: number;
    assetType: string;
    teamSlug: string;
}

export interface AssetsPortsTechnologiesRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface AssetsPortsWebListRequest {
    teamSlug: string;
    limit?: number;
    ordering?: string;
    page?: number;
    search?: string;
    statusCode?: number;
}

export interface AssetsScreenshotsRetrieveRequest {
    assetType: string;
    id: number;
    teamSlug: string;
}

export interface AssetsSubdomainsDomainRetrieveRequest {
    domainId: string;
    teamSlug: string;
}

export interface AssetsTagsCreateRequest {
    assetType: string;
    id: number;
    teamSlug: string;
}

export interface AssetsTagsRetrieveRequest {
    assetType: string;
    id: number;
    teamSlug: string;
}

export interface DomainsListRequest {
    teamSlug: string;
    findingsMax?: number;
    findingsMin?: number;
    limit?: number;
    ordering?: string;
    page?: number;
    riskScore?: string;
    riskScoreMax?: string;
    riskScoreMin?: string;
    search?: string;
}

export interface DomainsRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface IpAddressesListRequest {
    teamSlug: string;
    findingsMax?: number;
    findingsMin?: number;
    limit?: number;
    ordering?: string;
    page?: number;
    riskScore?: string;
    riskScoreMax?: string;
    riskScoreMin?: string;
    search?: string;
}

export interface IpAddressesRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface PortsListRequest {
    teamSlug: string;
    limit?: number;
    ordering?: string;
    page?: number;
    search?: string;
}

export interface PortsRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface SubdomainsListRequest {
    teamSlug: string;
    findingsMax?: number;
    findingsMin?: number;
    limit?: number;
    ordering?: string;
    page?: number;
    riskScore?: string;
    riskScoreMax?: string;
    riskScoreMin?: string;
    search?: string;
}

export interface SubdomainsRetrieveRequest {
    id: string;
    teamSlug: string;
}

/**
 * 
 */
export class AssetsApi extends runtime.BaseAPI {

    /**
     * GET /a/<team_slug>/api/all_screenshots/ Returns a paginated list of ports (across assets) that have screenshots.
     */
    async assetsAllScreenshotsListRaw(requestParameters: AssetsAllScreenshotsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPortList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling assetsAllScreenshotsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/all-screenshots/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPortListFromJSON(jsonValue));
    }

    /**
     * GET /a/<team_slug>/api/all_screenshots/ Returns a paginated list of ports (across assets) that have screenshots.
     */
    async assetsAllScreenshotsList(requestParameters: AssetsAllScreenshotsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPortList> {
        const response = await this.assetsAllScreenshotsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get ports for a specific asset
     */
    async assetsPortsForAssetRetrieveRaw(requestParameters: AssetsPortsForAssetRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Port>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling assetsPortsForAssetRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/ports/for_asset/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortFromJSON(jsonValue));
    }

    /**
     * Get ports for a specific asset
     */
    async assetsPortsForAssetRetrieve(requestParameters: AssetsPortsForAssetRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Port> {
        const response = await this.assetsPortsForAssetRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get ports for a specific asset
     */
    async assetsPortsRetrieveRaw(requestParameters: AssetsPortsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Port>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetsPortsRetrieve().'
            );
        }

        if (requestParameters['assetType'] == null) {
            throw new runtime.RequiredError(
                'assetType',
                'Required parameter "assetType" was null or undefined when calling assetsPortsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling assetsPortsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/{asset_type}/{asset_id}/ports/`.replace(`{${"asset_id"}}`, encodeURIComponent(String(requestParameters['assetId']))).replace(`{${"asset_type"}}`, encodeURIComponent(String(requestParameters['assetType']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortFromJSON(jsonValue));
    }

    /**
     * Get ports for a specific asset
     */
    async assetsPortsRetrieve(requestParameters: AssetsPortsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Port> {
        const response = await this.assetsPortsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get technologies for a specific port
     */
    async assetsPortsTechnologiesRetrieveRaw(requestParameters: AssetsPortsTechnologiesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Port>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assetsPortsTechnologiesRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling assetsPortsTechnologiesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/ports/{id}/technologies/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortFromJSON(jsonValue));
    }

    /**
     * Get technologies for a specific port
     */
    async assetsPortsTechnologiesRetrieve(requestParameters: AssetsPortsTechnologiesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Port> {
        const response = await this.assetsPortsTechnologiesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all HTTP/HTTPS ports for a team with an optional filter on status code
     */
    async assetsPortsWebListRaw(requestParameters: AssetsPortsWebListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPortList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling assetsPortsWebList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['statusCode'] != null) {
            queryParameters['status_code'] = requestParameters['statusCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/ports/web/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPortListFromJSON(jsonValue));
    }

    /**
     * Get all HTTP/HTTPS ports for a team with an optional filter on status code
     */
    async assetsPortsWebList(requestParameters: AssetsPortsWebListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPortList> {
        const response = await this.assetsPortsWebListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * GET /a/<team_slug>/api/<asset_type>/<pk>/screenshots/ Returns all ports (with screenshots) for the asset.
     */
    async assetsScreenshotsRetrieveRaw(requestParameters: AssetsScreenshotsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assetType'] == null) {
            throw new runtime.RequiredError(
                'assetType',
                'Required parameter "assetType" was null or undefined when calling assetsScreenshotsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assetsScreenshotsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling assetsScreenshotsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/{asset_type}/{id}/screenshots/`.replace(`{${"asset_type"}}`, encodeURIComponent(String(requestParameters['assetType']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * GET /a/<team_slug>/api/<asset_type>/<pk>/screenshots/ Returns all ports (with screenshots) for the asset.
     */
    async assetsScreenshotsRetrieve(requestParameters: AssetsScreenshotsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetsScreenshotsRetrieveRaw(requestParameters, initOverrides);
    }

    /**
     * List all subdomains for a specific domain
     */
    async assetsSubdomainsDomainRetrieveRaw(requestParameters: AssetsSubdomainsDomainRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subdomain>> {
        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling assetsSubdomainsDomainRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling assetsSubdomainsDomainRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/subdomains/domain/{domain_id}/`.replace(`{${"domain_id"}}`, encodeURIComponent(String(requestParameters['domainId']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubdomainFromJSON(jsonValue));
    }

    /**
     * List all subdomains for a specific domain
     */
    async assetsSubdomainsDomainRetrieve(requestParameters: AssetsSubdomainsDomainRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subdomain> {
        const response = await this.assetsSubdomainsDomainRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update tags for an asset
     */
    async assetsTagsCreateRaw(requestParameters: AssetsTagsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assetType'] == null) {
            throw new runtime.RequiredError(
                'assetType',
                'Required parameter "assetType" was null or undefined when calling assetsTagsCreate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assetsTagsCreate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling assetsTagsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/{asset_type}/{id}/tags/`.replace(`{${"asset_type"}}`, encodeURIComponent(String(requestParameters['assetType']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update tags for an asset
     */
    async assetsTagsCreate(requestParameters: AssetsTagsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetsTagsCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Get tags for an asset
     */
    async assetsTagsRetrieveRaw(requestParameters: AssetsTagsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assetType'] == null) {
            throw new runtime.RequiredError(
                'assetType',
                'Required parameter "assetType" was null or undefined when calling assetsTagsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assetsTagsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling assetsTagsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/{asset_type}/{id}/tags/`.replace(`{${"asset_type"}}`, encodeURIComponent(String(requestParameters['assetType']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get tags for an asset
     */
    async assetsTagsRetrieve(requestParameters: AssetsTagsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetsTagsRetrieveRaw(requestParameters, initOverrides);
    }

    /**
     */
    async domainsListRaw(requestParameters: DomainsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDomainList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling domainsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['findingsMax'] != null) {
            queryParameters['findings_max'] = requestParameters['findingsMax'];
        }

        if (requestParameters['findingsMin'] != null) {
            queryParameters['findings_min'] = requestParameters['findingsMin'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['riskScore'] != null) {
            queryParameters['risk_score'] = requestParameters['riskScore'];
        }

        if (requestParameters['riskScoreMax'] != null) {
            queryParameters['risk_score_max'] = requestParameters['riskScoreMax'];
        }

        if (requestParameters['riskScoreMin'] != null) {
            queryParameters['risk_score_min'] = requestParameters['riskScoreMin'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/domains/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDomainListFromJSON(jsonValue));
    }

    /**
     */
    async domainsList(requestParameters: DomainsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDomainList> {
        const response = await this.domainsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async domainsRetrieveRaw(requestParameters: DomainsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Domain>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling domainsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling domainsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/domains/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainFromJSON(jsonValue));
    }

    /**
     */
    async domainsRetrieve(requestParameters: DomainsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Domain> {
        const response = await this.domainsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async ipAddressesListRaw(requestParameters: IpAddressesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedIPAddressList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling ipAddressesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['findingsMax'] != null) {
            queryParameters['findings_max'] = requestParameters['findingsMax'];
        }

        if (requestParameters['findingsMin'] != null) {
            queryParameters['findings_min'] = requestParameters['findingsMin'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['riskScore'] != null) {
            queryParameters['risk_score'] = requestParameters['riskScore'];
        }

        if (requestParameters['riskScoreMax'] != null) {
            queryParameters['risk_score_max'] = requestParameters['riskScoreMax'];
        }

        if (requestParameters['riskScoreMin'] != null) {
            queryParameters['risk_score_min'] = requestParameters['riskScoreMin'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/ip-addresses/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedIPAddressListFromJSON(jsonValue));
    }

    /**
     */
    async ipAddressesList(requestParameters: IpAddressesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedIPAddressList> {
        const response = await this.ipAddressesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async ipAddressesRetrieveRaw(requestParameters: IpAddressesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPAddress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ipAddressesRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling ipAddressesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/ip-addresses/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPAddressFromJSON(jsonValue));
    }

    /**
     */
    async ipAddressesRetrieve(requestParameters: IpAddressesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPAddress> {
        const response = await this.ipAddressesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async portsListRaw(requestParameters: PortsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPortList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling portsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/ports/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPortListFromJSON(jsonValue));
    }

    /**
     */
    async portsList(requestParameters: PortsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPortList> {
        const response = await this.portsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async portsRetrieveRaw(requestParameters: PortsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Port>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling portsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling portsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/ports/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortFromJSON(jsonValue));
    }

    /**
     */
    async portsRetrieve(requestParameters: PortsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Port> {
        const response = await this.portsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subdomainsListRaw(requestParameters: SubdomainsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSubdomainList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling subdomainsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['findingsMax'] != null) {
            queryParameters['findings_max'] = requestParameters['findingsMax'];
        }

        if (requestParameters['findingsMin'] != null) {
            queryParameters['findings_min'] = requestParameters['findingsMin'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['riskScore'] != null) {
            queryParameters['risk_score'] = requestParameters['riskScore'];
        }

        if (requestParameters['riskScoreMax'] != null) {
            queryParameters['risk_score_max'] = requestParameters['riskScoreMax'];
        }

        if (requestParameters['riskScoreMin'] != null) {
            queryParameters['risk_score_min'] = requestParameters['riskScoreMin'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/subdomains/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSubdomainListFromJSON(jsonValue));
    }

    /**
     */
    async subdomainsList(requestParameters: SubdomainsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSubdomainList> {
        const response = await this.subdomainsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subdomainsRetrieveRaw(requestParameters: SubdomainsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Subdomain>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling subdomainsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling subdomainsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/assets/{team_slug}/subdomains/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubdomainFromJSON(jsonValue));
    }

    /**
     */
    async subdomainsRetrieve(requestParameters: SubdomainsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Subdomain> {
        const response = await this.subdomainsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
